(() => {
  const mount = (scope = document) => {
    scope.querySelectorAll('[data-sales-bundles]').forEach(section => {
      if (section.dataset.salesReady) return;
      section.dataset.salesReady = 'true';
      const media = matchMedia('(max-width: 749px)');
      const links = [...section.querySelectorAll('[data-bundle-select]')];
      const panels = [...section.querySelectorAll('[data-bundle-panel]')];
      let active = panels.find(panel => `#${panel.id}` === location.hash)?.id || panels[0]?.id;
      const sync = () => {
        panels.forEach(panel => { panel.hidden = media.matches && panel.id !== active; });
        links.forEach(link => {
          if (media.matches && link.dataset.bundleSelect === active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      links.forEach(link => link.addEventListener('click', event => {
        if (!media.matches) return;
        event.preventDefault();
        active = link.dataset.bundleSelect;
        sync();
      }));
      const onHash = () => {
        const panel = panels.find(item => `#${item.id}` === location.hash);
        if (panel) { active = panel.id; sync(); }
      };
      media.addEventListener('change', sync);
      window.addEventListener('hashchange', onHash);
      const unload = event => {
        if (!event.target.contains(section)) return;
        media.removeEventListener('change', sync);
        window.removeEventListener('hashchange', onHash);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
